module.exports = __webpack_public_path__ + "static/media/Logo__OOP.06a22b12.svg";